module.exports = __webpack_public_path__ + "static/media/External Grievance Policy.bdf9255e.pdf";